import type { ValidationStatus } from '@/data/validation';

interface MedicalInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  validationStatus?: ValidationStatus;
  validationMessage?: string;
  showInfoIcon?: boolean;
  onInfoPress?: () => void;
  inputMode?: 'numeric' | 'text';
}

export function MedicalInput({
  label,
  value,
  onChange,
  placeholder,
  validationStatus,
  validationMessage,
  showInfoIcon,
  onInfoPress,
  inputMode = 'numeric',
}: MedicalInputProps) {
  const isError = validationStatus === 'error';
  const isWarning = validationStatus === 'warning';

  return (
    <div className="mb-4">
      <div className="mb-1.5 flex items-center gap-1.5">
        <label className="text-[15px] font-medium text-text-heading">{label}</label>
        {showInfoIcon && (
          <button
            type="button"
            onClick={onInfoPress}
            className="rounded px-1 py-0.5 text-base font-bold text-primary hover:bg-primary/6 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1"
            aria-label="Bilgi"
          >
            (?)
          </button>
        )}
      </div>
      <input
        type="text"
        inputMode={inputMode}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full rounded-xl border-2 px-4 py-3.5 text-base outline-none transition min-h-[48px]
          ${isError ? 'border-error bg-error-bg' : ''}
          ${isWarning ? 'border-warning bg-warning-bg' : ''}
          ${!isError && !isWarning ? 'border-slate-200 bg-card-bg focus:border-primary' : ''}
          focus:ring-2 focus:ring-primary/20 focus:outline-none
        `}
      />
      {validationMessage && (
        <p
          className={`mt-1 text-xs ${isError ? 'text-error' : ''} ${isWarning ? 'text-warning' : ''}`}
        >
          {validationMessage}
        </p>
      )}
    </div>
  );
}
